<template>

  <div>
    <v-tooltip max-width="250"
               color="accent black--text"
               bottom
               v-if="item.description">

      <template v-slot:activator="{ on }">
        <v-sheet v-on="on"
                 @click="handleClick(item)"
                 :height="Number(height)"
                 :color="disableColor ? 'blue lighten-2' : color"
                 :dark="false"
                 class="ma-2 text-center d-flex flex-column justify-center"
                 :class="hover ? 'elevation-5' : ''">
          <slot></slot>
        </v-sheet>
      </template>

      <div class="tip-content">
        <div class="text-justify">
          <div v-if="selectionType === 'businessSpeed'">
            {{createSpeedDescription(item)}}
          </div>
          <div v-else>
            {{item.description}}
          </div>
        </div>
        <div class="text-center mt-3" v-if="speedString">
          <v-chip small label color="grey lighten-2" class="d-block">
            {{speedString}}
          </v-chip>
        </div>
      </div>

    </v-tooltip>

    <div v-else class="fill-height">
      <slot></slot>
    </div>
  </div>

</template>

<script>

export default {

  name: 'Wizard.Card',

  props: {

    height: {
      type: [Number, String],
      required: false,
      default: 150,
    },

    selectionType: {
      type: String,
      required: true,
    },

    item: {
      type: Object,
      required: true,
    },

    color: {
      type: String,
      required: false,
      default: '#CCC',
    },

    disableColor: {
      type: Boolean,
      required: false,
      default: false,
    },

    category: {
      type: Object,
      required: false,
    },

  },

  data() {
    return {
      hover: false,
    };
  },

  computed: {
    speedString() {
      if (this.category) {
        const speed = this.item.number[this.category.value];
        if (speed >= 1000) {
          return `${speed / 1000} Gbps`;
        } else {
          return `${speed} Mbps`;
        }
      }
      return null;
    },
  },

  methods: {

    handleMouseEnter() {
      this.hover = true;
    },

    handleMouseOut() {
      this.hover = false;
    },

    // receive a value from the click event in the DOM and emit
    // event for parent to receive as a key/value object
    handleClick($event) {
      this.$emit('card-clicked', {
        key: this.selectionType,
        value: $event,
      });
    },

    createSpeedDescription(item) {
      if (this.category) {
        return item.description.replace('{}', this.speedString);
      }
      return null;
    },

  },

};
</script>
